import React from "react";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<div className="works-card">
				<div className="works-card-container">
					<div className="works-card-header">
						<span className="works-card-label">RECENT WORK</span>
					</div>
					<div className="works-body">
						<div className="work">
							<div className="work-header">
								<img
									src="./youngcorp.svg"
									alt="Young Corporation"
									className="work-image"
								/>
								<div className="work-title">
									Software Engineer (Home Automation and
									Internal Tools)
								</div>
							</div>
							<div className="work-subtitle">
								Young Corporation
							</div>
							<div className="work-duration">
								September 2021 - April 2024
							</div>
						</div>

						<div className="work">
							<div className="work-header">
								<img
									src="./gatech.jpg"
									alt="CSE"
									className="work-image"
								/>
								<div className="work-title">
									Senior Student Assistant (Tech Focus)
								</div>
							</div>
							<div className="work-subtitle">
								Georgia Tech Center for Student Engagement
							</div>
							<div className="work-duration">
								September 2021 - April 2024
							</div>
						</div>

						<div className="work">
							<div className="work-header">
								<img
									src="./gatech.jpg"
									alt="Digital Deliberation"
									className="work-image"
								/>
								<div className="work-title">
									Development Team Member
								</div>
							</div>
							<div className="work-subtitle">
								Reflect! Research Team
							</div>
							<div className="work-duration">
								August 2023 - December 2023
							</div>
						</div>
					</div>
				</div>
				<div className="works-corner top-left" />
				<div className="works-corner top-right" />
				<div className="works-corner bottom-left" />
				<div className="works-corner bottom-right" />
			</div>
		</div>
	);
};

export default Works;
